import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Station} from "../models/Station";
import {map} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {Project} from '../models/project';
export interface ProjetResponse {
    projectsListe: Project[];
}
@Injectable({
  providedIn: 'root'
})
export class ProjetService {
  private apiUrl = environment.parameters_url;
  private baseUrl = `${this.apiUrl}api/settings/projects`;

  constructor(private http: HttpClient) { }

  /*getProjectsByIdStation(stationId: number): Observable<any[]> {
    return this.http.get<any>(`${this.baseUrl}/${stationId}`);
  }*/

  getProjectsByIdStation(stationId: number): Observable<any[]> {
    return this.http.get<any>(`${this.baseUrl}/${stationId}`).pipe(
        map(response => response.projectsListe)
    );
  }


  toggleProjectStatus(stationId: number, projectId: number, updatedStatus: boolean): Observable<any> {
    const url = `${this.baseUrl}/${stationId}/${projectId}`;
    return this.http.put(url, { statut: updatedStatus });
  }

  addProject(stationId: number, project: { client_id: number; libelle: string; statut: boolean }): Observable<any> {
    const url = `${this.baseUrl}/${stationId}/`;
    return this.http.post(url, project);
  }

  updateProject(stationId: number, projectId: number, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/${stationId}/${projectId}`, payload);
  }

}
